import { FieldRequirement } from "../components/FieldRequirement";
import { useLocale } from "../i18n";

export function AdultConfirmation({ id, checked, onChange, disabled }: {
  id: string; checked: boolean; onChange: (value: boolean) => void; disabled: boolean;
}) {
  const { w } = useLocale();
  return <div>
    <label className="entry-adult-confirmation" htmlFor={id}>
      <input id={id} type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)} required disabled={disabled} />
      <span>{w("أؤكد أن عمري 18 عامًا أو أكثر", "I confirm that I am 18 or older")}<FieldRequirement required={true} /></span>
    </label>
    <p className="entry-field-hint">{w("هذا إقرار بالأهلية العمرية، وليس إثبات هوية. لا يلزم إدخال تاريخ الميلاد الدقيق.", "This is an age declaration, not identity verification. Your exact date of birth is not required.")}</p>
  </div>;
}
